import { TEDCustomDateTimeDisplayer } from './TEDCustomDateTimeDisplayer';
import { TEDParseDateTimeMode } from '../FormatterTypes';

class TEDDisplayDate extends TEDCustomDateTimeDisplayer {
  public static getInstance(): TEDDisplayDate {
    return this.instance ? this.instance : (this.instance = new this());
  }

  private static instance: TEDDisplayDate;
  public mode() {
    return TEDParseDateTimeMode.pdmYMD;
  }
}

export { TEDDisplayDate };
